export const getFilterAttributeValue = ({
  valueBool,
  valueStr,
  from,
  to,
}: GetFilterAttributeValueArgs) => {
  if (typeof valueBool === 'boolean') {
    return String(valueBool)
  }
  if (typeof valueStr === 'string') {
    return valueStr
  }

  const fromString = from?.toString()
  const toString = to?.toString()

  return `${fromString ? from : ''}${fromString && toString ? '-' : ''}${toString ? to : ''}`
}

export const getAriaLabel = (label?: string, count?: number) => {
  if (!label || !count) {
    return
  }

  /*
    The comma between label & count ensures the screen reader says 'No' instead of 'Number'
    This is important on techspec filters e.g. Televisions > Features > Freesat HD
    Many places have reported this issue with the ChromeVox screen reader extension
    e.g. https://github.com/angular/components/issues/20815

    The comma at the end is for consistent pacing
  */
  return `${label.replace('"', ' inches')}, ${count} product${count === 1 ? '' : 's'},`
}

///////// IMPLEMENTATION /////////

type GetFilterAttributeValueArgs = {
  valueBool?: boolean | null
  valueStr?: string | null
  from?: number | null
  to?: number | null
}
